export const ALERTS_ADD = 'alerts/ALERTS_ADD';
export const ALERTS_REMOVE = 'alerts/ALERTS_REMOVE ';
